import React from 'react'

const Crypto = () => {
  return (
    <>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24">
        <g id="vuesax_bold_buy-crypto" data-name="vuesax/bold/buy-crypto" transform="translate(-236 -188)">
            <g id="buy-crypto">
            <path id="Vector" d="M12.92,6.5A6.5,6.5,0,0,1,7.4,12.92v-.06A8.064,8.064,0,0,0,.03,5.52H0a6.5,6.5,0,0,1,12.92.98Z" transform="translate(245.08 190)" fill="#fff"/>
            <path id="Vector-2" data-name="Vector" d="M0,0H24V24H0Z" transform="translate(236 188)" fill="none" opacity="0"/>
            <path id="Vector-3" data-name="Vector" d="M12.98,5.98A6.509,6.509,0,0,0,7.02.02C6.85.01,6.67,0,6.5,0A6.5,6.5,0,1,0,13,6.5C13,6.33,12.99,6.15,12.98,5.98Zm-5.6,1.4L6.5,9,5.62,7.38,4,6.5l1.62-.88L6.5,4l.88,1.62L9,6.5Z" transform="translate(238 197)" fill="#fff"/>
            </g>
        </g>
    </svg>
    </>
  )
}

export default Crypto